import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'cv-view-reason-modal',
    templateUrl: './view-reason-modal.component.html',
    styleUrls: ['./view-reason-modal.component.scss']
})
export class ViewReasonModalComponent implements OnInit {
    public modalTitle: string;
    public cancelLabel: string;
    public content: string;

    constructor(private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) { }

    ngOnInit(): void {
        if (this.dialogConfig.data !== null) {
            this.modalTitle = this.dialogConfig.data.title;
            this.cancelLabel = this.dialogConfig.data.cancelLabel;
            this.content = this.dialogConfig.data.content;
        }
    }

    onClose() {
        this.dialogRef.close();
    }
}
